export default __webpack_public_path__ + "static/media/english.3958fdb1.jpg";